import { Injectable } from "@angular/core";
import { CanActivate, CanActivateChild, Router } from "@angular/router";
import { AuthRepository } from "../state/auth.repository";
import { AuthEventsService } from "./events.service";

@Injectable()
export class AuthGuardService implements CanActivate, CanActivateChild {

  constructor(
    private router: Router,
    private authRepo: AuthRepository,
    private events: AuthEventsService,
  ) { }

  canActivate(): boolean {
    if (this.authRepo.isLoggedIn()) return true;
    this.events.unauthenticated.next({
      code: 'unauthenticated',
      message: 'Usuário não autenticado',
      data: null
    });
    this.router.navigateByUrl('login');
    return false;
  }

  canActivateChild(): boolean {
    return this.canActivate();
  }

}
